export default __webpack_public_path__ + "static/media/prva.082dd5df.png";